(function () {
  var script = document.currentScript;
  var redirectUrl = (script && script.dataset.redirectUrl) || '/pages/quiz-results?view=quiz-results';
  var STORAGE_KEY = 'octane_quiz_results_gz';

  function compress(json) {
    var stream = new Blob([json]).stream().pipeThrough(new CompressionStream('gzip'));
    return new Response(stream).arrayBuffer().then(function (buf) {
      var bytes = new Uint8Array(buf);
      var binary = '';
      for (var i = 0; i < bytes.length; i++) {
        binary += String.fromCharCode(bytes[i]);
      }
      return btoa(binary);
    });
  }

  function handleQuizResult(e) {
    var json;
    try {
      json = JSON.stringify(e.detail);
    } catch (_) {
      return;
    }

    compress(json)
      .then(function (compressed) {
        try {
          sessionStorage.setItem(STORAGE_KEY, compressed);
          window.location.href = redirectUrl;
        } catch (_) {
          /* storage full or blocked — stay on quiz page */
        }
      })
      .catch(function () {
        try {
          sessionStorage.setItem(STORAGE_KEY, json);
          window.location.href = redirectUrl;
        } catch (_) {
          /* storage full or blocked — stay on quiz page */
        }
      });
  }

  document.addEventListener('octane.quiz.completed', handleQuizResult, false);
  document.addEventListener('octane.quiz.accessed', handleQuizResult, false);
})();
